const styles = theme => ({
  root: {},
  loading: {
    margin: '0',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex:1302
  },
  cover: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    background: '#000',
    opacity: '.2',
    top: '0px',
    left: '0px',
    zIndex:1301
  },
})

export default styles
